export default {

	data() {
		return {
			quizActive: true,
			activeQuestion: null,
			answerResponse: null,
			activeQuestionAnswered: null,
			openToStats: false,
			autoOpenTimeout: null,
			autoOpenCookieKey: null
		}
	},

	computed: {
		shouldShowQuiz() {
			if (!this.quizzes || this.quizzes.length === 0 || !this.quizzes[0]) {
				return false;
			}
			
			const quiz = this.quizzes[0];
			const now = new Date();
			
			// Don't show if before advertise date
			if (quiz.advertiseDateTime) {
				const advertiseDate = new Date(quiz.advertiseDateTime);
				if (now < advertiseDate) {
					return false;
				}
			}
			
			// Don't show if after closed until date
			if (quiz.showClosedUntilDateTime) {
				const showClosedUntil = new Date(quiz.showClosedUntilDateTime);
				if (now > showClosedUntil) {
					return false;
				}
			}
			
			return true;
		}
	},

	methods: {

		isQuestionToday(question) {
			if (!question || !question.startDateTime || !question.endDateTime) {
				return false;
			}
			
			const now = new Date();
			const startDate = new Date(question.startDateTime);
			const endDate = new Date(question.endDateTime);
			
			return now >= startDate && now <= endDate;
		},

		loadQuizData() {
			this.activeQuestionAnswered = null;
			this._getQuizzes(true, false, false, () => {
				this.activeQuestion = this.quizzes[0]?.questions.find(q => this.isQuestionToday(q));
				this._getQuizPoints(this.quizzes[0]?.id, () => {
					this._getQuizAnswers(this.quizzes[0]?.id, () => {
						this.activeQuestionAnswered = false;
						if (this.activeQuestion) {
							const thisQuestionAnswered = this.quizAnswers.find(a => a.question.id === this.activeQuestion.id);
							this.activeQuestionAnswered = thisQuestionAnswered && thisQuestionAnswered.selectedAnswer != null;
							
						// Auto-open drawer if quiz is active, question not answered, and not auto-opened before for this question
						const autoOpenCookieKey = `quiz_auto_opened_${this.activeQuestion.id}`;
						const hasAutoOpened = this.$cookies.get(autoOpenCookieKey);
						
						if (!this.activeQuestionAnswered && this.shouldShowQuiz && !hasAutoOpened) {
							// Clean up old quiz auto-open cookies before setting new one
							const allCookies = this.$cookies.keys();
							allCookies.forEach(cookieKey => {
								if (cookieKey.startsWith('quiz_auto_opened_') && cookieKey !== autoOpenCookieKey) {
									this.$cookies.remove(cookieKey);
								}
							});
							
							// Store cookie key for potential cleanup on navigation
							this.autoOpenCookieKey = autoOpenCookieKey;
							
							// Delay auto-open by 3 seconds
							this.autoOpenTimeout = setTimeout(() => {
									// Check if component still exists and refs are available
									if (this.$refs && this.$refs.quizPlayDrawer) {
										// Set cookie to prevent auto-opening again for this question (expires in 24 hours)
										this.$cookies.set(autoOpenCookieKey, 'true', '1d');
										this.autoOpenCookieKey = null; // Clear the key since we've successfully opened
										
										this.$nextTick(() => {
											this.handleAnswerClick();
										});
									}
								}, 1000);
							}
						}
					});
				});
			});
		},

		handleRulesClick() {
			// Cancel auto-open if user manually opens drawer
			if (this.autoOpenTimeout) {
				clearTimeout(this.autoOpenTimeout);
				this.autoOpenTimeout = null;
				this.autoOpenCookieKey = null;
			}
			this.$refs.quizRulesDrawer.openDrawer();
		},

		handleAnswerClick() {
			// Cancel auto-open if user manually opens drawer
			if (this.autoOpenTimeout) {
				clearTimeout(this.autoOpenTimeout);
				this.autoOpenTimeout = null;
				this.autoOpenCookieKey = null;
			}
			this.openToStats = false;
			this.$nextTick(() => {
				this.$refs.quizPlayDrawer.openDrawer();
			});
		},

		handleShowStatsClick() {
			// Cancel auto-open if user manually opens drawer
			if (this.autoOpenTimeout) {
				clearTimeout(this.autoOpenTimeout);
				this.autoOpenTimeout = null;
				this.autoOpenCookieKey = null;
			}
			this.openToStats = true;
			this.$nextTick(() => {
				this.$refs.quizPlayDrawer.openDrawer();
			});
		},		
		
		handleHome() {
			// Reset to null to hide the card during reload
			this.activeQuestionAnswered = null;
			
			this._getQuizzes(true, false, false, () => {
				this.activeQuestion = this.quizzes[0]?.questions.find(q => this.isQuestionToday(q));
				this._getQuizPoints(this.quizzes[0].id);
				this._getQuizAnswers(this.quizzes[0].id, () => {
					if (this.activeQuestion) {
						const thisQuestionAnswered = this.quizAnswers.find(a => a.question.id === this.activeQuestion.id);
						this.activeQuestionAnswered = thisQuestionAnswered && thisQuestionAnswered.selectedAnswer != null;
					} else {
						// No active question means quiz is finished
						this.activeQuestionAnswered = true;
					}
				});
			});
		},

		handleSubmitAnswer(quiz, answer) {
			// Clear previous answer response to prevent showing old data
			this.answerResponse = null;
			
			const question = quiz.questions.find(q => this.isQuestionToday(q));
			this._postQuizAnswer(quiz.id, question.id, answer.id, (response) => {
				this._clearQuizCache(quiz.id);
				this.answerResponse = response;
			});
		},	
		handleTermsClick() {
			this.$refs.quizTermsDrawer.openDrawer();
		},
	
		handleNotificationsChange(enabled) {
		// Initialize preferences if they don't exist
		if (!this.customer.preferences) {
			this.customer.preferences = { 
				dailyCurrentBalanceNotifications: false, 
				dailyCreditBalanceNotifications: false, 
				quizNotifications: false
			};
		}
		
		// Update the quiz notifications preference
		this.customer.preferences.quizNotifications = enabled;
		
		// Save preferences using the Services mixin method
		this._savePreferences(() => {
			console.log('Quiz notifications preference saved:', enabled);
		});
	},

	handleQuizDrawerOpened() {
		document.body.classList.add('quiz-drawer-active');
	},
	
	handleQuizDrawerClosed() {
		document.body.classList.remove('quiz-drawer-active');
	}

	},

	beforeUnmount() {
		// Cancel auto-open timeout if user navigates away
		if (this.autoOpenTimeout) {
			clearTimeout(this.autoOpenTimeout);
			this.autoOpenTimeout = null;
		}
		
		// Remove the auto-open cookie if user navigates away before drawer opens
		if (this.autoOpenCookieKey) {
			this.$cookies.remove(this.autoOpenCookieKey);
			this.autoOpenCookieKey = null;
		}
	}
}
